import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { auth } from '../../lib/adminApi';
import { Lock, Mail } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  if (auth.isAuthed()) return <Navigate to="/admin/blog" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await auth.login(email.trim().toLowerCase(), password);
      navigate('/admin/blog');
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === 'string' ? d : 'Sign-in failed. Check email and password.');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-navy-deep flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-mk-lg p-8">
        <p className="text-brand-pink text-[11px] font-bold uppercase tracking-[0.18em]">5DBS Admin</p>
        <h1 className="mt-2 text-navy font-black tracking-[-0.005em] text-[26px]">Sign in</h1>
        <p className="mt-2 text-body-muted text-[14px]">Manage blog posts and site content.</p>

        <form onSubmit={submit} className="mt-7 space-y-5" data-testid="admin-login-form">
          <label className="block">
            <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-body-muted">Email</span>
            <div className="mt-1 flex items-center gap-2 border-b-2 border-slate-200 focus-within:border-brand-blue">
              <Mail className="h-4 w-4 text-body-muted" />
              <input
                type="email" required value={email} data-testid="admin-email"
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 h-11 bg-transparent text-navy text-[15px] outline-none"
                placeholder="admin@fivedbs.com"
              />
            </div>
          </label>
          <label className="block">
            <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-body-muted">Password</span>
            <div className="mt-1 flex items-center gap-2 border-b-2 border-slate-200 focus-within:border-brand-blue">
              <Lock className="h-4 w-4 text-body-muted" />
              <input
                type="password" required value={password} data-testid="admin-password"
                onChange={(e) => setPassword(e.target.value)}
                className="flex-1 h-11 bg-transparent text-navy text-[15px] outline-none"
                placeholder="••••••••"
              />
            </div>
          </label>

          {err && (
            <p role="alert" data-testid="admin-login-error" className="text-rose-600 text-[13px]">{err}</p>
          )}

          <button
            type="submit" disabled={busy} data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center h-11 rounded-md bg-brand-pink hover:bg-brand-pink/90 text-white text-[13px] font-bold uppercase tracking-[0.08em] shadow-mk hover:shadow-mk-lg transition-all duration-300 disabled:opacity-60"
          >
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
